(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("chips", [], factory);
	else if(typeof exports === 'object')
		exports["chips"] = factory();
	else
		root["chips"] = factory();
})(this, function() {
return 